export const ROUTES = {
	ACCEPT_INVITE: "/accept-invite",
	ACCOUNT_ACTIVATION: "/activate-account",
	ALL_ACTIVITY: "/all-activity",
	ANALYTICS: "/analytics",
	CASE_MANAGEMENT: "/case-management",
	DASHBOARD: "/dashboard",
	EVENTS: "/events",
	EXPORTS: "/exports",
	LOCATION_MANAGEMENT: "/settings/locations",
	LOGIN: "/login",
	MANAGE_PROFILE: "/settings/manage-profile",
	NOT_FOUND: "*",
	SETTINGS: "/settings",
	SOP_MANAGEMENT: "/settings/sop",
	SUPPORT: "/support",
	USER_INVITE: "/settings/users/invite",
	USER_MANAGEMENT: "/settings/users",
	WATCHLIST: "/watchlist",
	WATCHLIST_CREATE: "/watchlist/create",
} as const;
